/**
 * List normalizer:
 * Converts API lists into our internal format.
 * @see {@link https://docs.joinmastodon.org/entities/list/}
 */import{Record as ImmutableRecord,Map as ImmutableMap,fromJS}from'immutable';// https://docs.joinmastodon.org/entities/list/
export var ListRecord=ImmutableRecord({id:'',title:'',replies_policy:null});export var normalizeList=function normalizeList(list){return ListRecord(ImmutableMap(fromJS(list)));};